module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0066.51759d4c.jpg";